import { populateCoverImage } from './utils';

export default function (vm, options = {}) {
  const recipes = options.data || [];

  return recipes.map(recipe => ({
    title: recipe.title,
    spot: recipe.spot,
    hasVideo: !!recipe.coverVideo,
    duration: recipe.videoDuration,
    authorId: undefined,
    createdDate: recipe.createdDate,
    coverImage: recipe.coverImage ? populateCoverImage(recipe) : {},
    entityType: undefined,
    headlineTypeId: undefined,
    images: undefined,
    order: undefined,
    siteId: undefined,
    url: recipe.urlPath || recipe.url,
    externalLink: '',
    sourceEntity: {
      id: recipe.id,
      content: recipe.content,
      publishDate: recipe.publishDate,
      updatedDate: recipe.updatedDate,
      user: recipe.user,
      categoryId: recipe.categoryId,
      categoryName: recipe.categoryName,
      categoryLinkName: recipe.categoryLinkName,
      mainCategoryId: recipe.mainCategoryId,
      mainCategoryName: recipe.mainCategoryName,
      isChiefSelection: recipe.isChiefSelection,
      rank: recipe.rank,
      preparationTime: recipe.preparationTime,
      cookingTime: recipe.cookingTime,
      difficultyId: recipe.difficultyId,
      totalPreparationTime: recipe.totalPreparationTime,
    },
    videoUrl: recipe.coverVideo,
  }));
}
